import { Topbar, Page, CardGridWrapper } from 'components'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { CustomerList } from 'views/customers/customerList'
import { RoutingStore } from '../stores'
import { MainSidebar, ParticipantView } from '../views'
import { CompanyUsers } from 'views/customers/companyUsers'
import { UserCourseList } from 'views/customers/userCourseList'
import { Pages, RoutingParams } from 'routes'
import { useParams } from 'react-router'
import { DataType } from 'types'
import { useTranslation } from 'react-i18next'
import { Company } from 'models'

export interface ICustomersProps {
  routingStore?: RoutingStore,
}

/**
 * Displays an overview list of all customers in the system for admins
 *
 * @type Admin
 */
export const Customers = inject('routingStore')(observer((props: ICustomersProps) => {
  const { routingStore } = props;
  const { t } = useTranslation();
  const params: RoutingParams = useParams<RoutingParams>();

  const [company, setCompany] = React.useState<Company>(null);

  let view: React.ReactNode;

  React.useEffect(() => props.routingStore.setParams(params), [params]);

  React.useEffect(() => {
    Company.get(Number(params.id)).then((c: Company) => setCompany(c));
  }, [params.id]);

  if (!params.id) {
    view = <CustomerList/>;
  } else if (params.id) {
    switch(params.view) {
      case 'users':
        view =  params.subid ? <UserCourseList/> : <CompanyUsers/>;
        break;
      case 'programs':
        view = view = Boolean(params.subid) 
          ? <ParticipantView contentType={DataType.Program} />
          : <CardGridWrapper 
              useCatalog
              showSorting
              contentType   = {DataType.Program}
              title         = {`${t('programs')} - ${company?.title}`}
              desc          = {t('manager_programs_description')}
              onCardClick = {(c) => routingStore.push(Pages.Customers, {
                ...routingStore.getCustomerRoutingParams('programs'),
                subid: ""+c.id
              })}
            />;
        break;
      default:
        throw new Error("Something went wrong! Invalid route");
    }
  } 

  return (
    <Page sidebar={<MainSidebar />} topbar={<Topbar showBackButton={Boolean(params.id)} />}>
      {view}
    </Page>
  );
}));